const Analitycs = () => {
  return (
    <div className="content-page-admin">
      <div className="title-page-admin">
        <i className="bx bx-pie-chart-alt-2"></i>
        <p>Analitycs page</p>
      </div>
    </div>
  );
};

export default Analitycs;
